module.exports = __webpack_public_path__ + "static/media/matcha-framboise.e95982a8.png";